// Source of truth: back-end/core-api/src/common/parse/domain/entities/DataUploadModel.py (DocumentCategory enum).
// Keep these values in sync — the backend persists the raw enum name on data_upload_file.document_category.
export type DocumentCategory =
  | 'FACT_FIND'
  | 'IO_FUND_VALUATION'
  | 'MEETING_NOTE'
  | 'GENERAL_AUDIO'
  | 'ATTITUDE_TO_RISK'
  | 'CASHFLOW_MODEL'
  | 'PRODUCT_ILLUSTRATION'
  | 'PRODUCT_FACTSHEET'
  | 'PRODUCT_STATEMENT'
  | 'BANK_ACCOUNT_STATEMENT'
  | 'EMAIL_CORRESPONDENCE'
  | 'REPORT_REQUEST'
  | 'SUITABILITY_REPORT'
  | 'POLICY_DOCUMENT'
  | 'CLIENT_AGREEMENT'
  | 'ESTATE_PLANNING_DOCUMENT'
  | 'TAX_DOCUMENT'
  | 'VULNERABILITY_ASSESSMENT'
  | 'IDENTITY_DOCUMENT'
  | 'GENERAL';

const DOCUMENT_CATEGORY_LABELS: Record<DocumentCategory, string> = {
  FACT_FIND: 'Fact find',
  IO_FUND_VALUATION: 'IO fund valuation',
  MEETING_NOTE: 'Meeting note',
  GENERAL_AUDIO: 'General audio',
  ATTITUDE_TO_RISK: 'Attitude to risk',
  CASHFLOW_MODEL: 'Cashflow model',
  PRODUCT_ILLUSTRATION: 'Product illustration',
  PRODUCT_FACTSHEET: 'Product factsheet',
  PRODUCT_STATEMENT: 'Product statement',
  BANK_ACCOUNT_STATEMENT: 'Bank account statement',
  EMAIL_CORRESPONDENCE: 'Email correspondence',
  REPORT_REQUEST: 'Report request',
  SUITABILITY_REPORT: 'Suitability report',
  POLICY_DOCUMENT: 'Policy document',
  CLIENT_AGREEMENT: 'Client agreement',
  ESTATE_PLANNING_DOCUMENT: 'Estate planning document',
  TAX_DOCUMENT: 'Tax document',
  VULNERABILITY_ASSESSMENT: 'Vulnerability assessment',
  IDENTITY_DOCUMENT: 'Identity document',
  GENERAL: 'General',
};

function formatDocumentCategory(
  category: DocumentCategory | string | null | undefined,
): string | undefined {
  if (!category) return undefined;
  return DOCUMENT_CATEGORY_LABELS[category as DocumentCategory] ?? undefined;
}

type FileTypeLabelSource = {
  documentCategory?: DocumentCategory | string | null;
  dataUploadModel?: { shortName?: string; displayName?: string } | null;
};

export function getFileTypeLabel(file: FileTypeLabelSource): string | undefined {
  return (
    formatDocumentCategory(file.documentCategory) ??
    file.dataUploadModel?.shortName ??
    file.dataUploadModel?.displayName
  );
}

export function getDocumentTypeLabel(file: FileTypeLabelSource & { isFolder: boolean }): string {
  if (file.isFolder) return 'Folder';
  return getFileTypeLabel(file) ?? 'General';
}
